import React, { useEffect, useRef, useState } from "react";
import { Box, Button, Stack, Divider, IconButton } from "@mui/material";
import useResponsive from "../../../Hooks/useResponsive";
import { Icon } from "@iconify/react/dist/iconify.js";

const DynamicTopMainAndSubNavbar = ({
  topBarDatas = [],
  selectedTopId,
  setSelectedTopId,
  selectedChildId,
  setSelectedChildId,
  isShowHidButtonRequired
}) => {
  const [showTab, setShowTab] = useState(true);
  const scrollRef = useRef();
  const scroll = (direction) => {
    if (!scrollRef.current) return;
    const scrollAmount = direction === "left" ? -150 : 150;
    scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
  };

  const scrollRefChild = useRef();
  const scrollChild = (direction) => {
    if (!scrollRefChild.current) return;
    const scrollAmount = direction === "left" ? -150 : 150;
    scrollRefChild.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
  };

  const mdUp = useResponsive("up", "md");

  const selectedTopItem = topBarDatas.find((item) => item.id === selectedTopId); //THE ITEM IS SELECTED AS THE 1ST OBJECT OF TOP NAVBAR ITEM
  const childItems = selectedTopItem?.childrens || []; //IF TH SELECTED ITEM HAS CHILDRENS THEN THE CHILDRENS ARRAY JUST ADDED TO THIS CHILD ITEMS

  useEffect(() => {
    if (
      selectedTopItem?.component == null &&
      selectedTopItem?.childrens.length &&
      selectedChildId === null // Only set default if none selected
    ) {
      setSelectedChildId(selectedTopItem?.childrens[0].id);
    }
  }, [selectedTopItem, selectedChildId]);

  const renderedComponent = (() => {
    // Case: Child is selected, show child component
    if (childItems.length > 0 && selectedChildId) {
      const selectedChild = childItems.find(
        (child) => child.id === selectedChildId
      );
      return selectedChild?.component || null;
    }

    // Case: Parent has component, render it
    return selectedTopItem?.component || null;
  })();

  if (topBarDatas.length === 0) {
    return <Box p={2}>No data provided.</Box>;
  }

  const parentFontSize = mdUp ? "0.7rem" : "0.65rem";
  const childFontSize = mdUp ? "0.6rem" : "0.5rem";
  return (
    <>
      <Box>
        <Button
          sx={{
            display:isShowHidButtonRequired?'inline-flex':"none",
            mb:0.8,
            minWidth: { xs: "95px", sm: "105px" },
            minHeight: 28,
            fontSize: {
              xs: "0.56rem",
              sm: "0.65rem",
            },
            borderRadius: "4px",
              boxShadow: "none",
          
          }}
          variant={"contained"}
          color="secondary"
          onClick={() => setShowTab((prev) => !prev)}
          size="small"
          startIcon={
            showTab ? (
              <Icon icon="icon-park-solid:up-c" />
            ) : (
              <Icon icon="icon-park-solid:down-c" />
            )
          }
        >
          {showTab ? "HIDE TAB" : "SHOW TAB"}
        </Button>
      </Box>

      <Box sx={{ display: showTab ? "block" : "none" }}>
        <Box
          p={mdUp ? 1 : 0.5}
          sx={{
            display: "flex",
            direction: "row",
            // justifyContent: "center",
            gap: 1,
            alignItems: "center",
            borderRadius: 2,
            border: "0.5px solid #97b8d9",
          }}
        >
          <IconButton
            sx={{
              bgcolor: "primary.main", // background color
              color: "white", // icon color
              "&:hover": {
                bgcolor: "info.dark", // optional hover effect
              },
            }}
            onClick={() => scroll("left")}
            size="small"
          >
            <Icon icon="mdi:chevron-left" width={20} height={20} />
          </IconButton>
          <Box
            ref={scrollRef}
            sx={{
              display: "flex",
              gap: 1,
              overflowX: "auto",
              scrollbarWidth: "none", // hide scrollbar in Firefox
              "&::-webkit-scrollbar": { display: "none" }, // hide in Chrome/Safari
              flex: 1,
            }}
          >
            {topBarDatas.map((item) => (
              <Button
                sx={{
                  fontSize: parentFontSize,
                  boxShadow: "none",
                  borderRadius: 0.5,
                  px: mdUp ? 3 : 1,
                }}
                color="primary"
                size="small"
                key={item.id}
                variant={item.id === selectedTopId ? "contained" : "outlined"}
                onClick={() => {
                  setSelectedTopId(item.id);
                  setSelectedChildId(null);
                }}
                startIcon={mdUp ? item?.icon : null}
              >
                {item.buttonName}
              </Button>
            ))}
          </Box>
          <IconButton
            sx={{
              bgcolor: "primary.main", // background color
              color: "white", // icon color
              "&:hover": {
                bgcolor: "info.dark", // optional hover effect
              },
            }}
            onClick={() => scroll("right")}
            size="small"
          >
            <Icon icon="mdi:chevron-right" width={20} height={20} />
          </IconButton>
        </Box>

        {childItems.length > 0 && (
          <Box
            p={mdUp ? 0.6 : 0.3}
            sx={{
              display: "flex",
              direction: "row",
              gap: 1,
              alignItems: "center",
            }}
          >
            <IconButton
              sx={{
                visibility: "hidden",
                bgcolor: "primary.main",
                color: "white",
                "&:hover": {
                  bgcolor: "info.dark",
                },
              }}
              onClick={() => scrollChild("left")}
              size="small"
            >
              <Icon icon="mdi:chevron-left" width={20} height={20} />
            </IconButton>

            <Box
              ref={scrollRefChild}
              sx={{
                display: "flex",
                gap: 1,
                // overflowX: "auto",
                // scrollbarWidth: "none",
                // "&::-webkit-scrollbar": { display: "none" },
                flexWrap: "wrap",
              }}
            >
              {childItems.map((child) => (
                <Button
                  key={child.id}
                  sx={{
                    fontSize: childFontSize,
                    boxShadow: "none",
                    borderRadius: 2,
                    px: mdUp ? 3 : 1,
                  }}
                  color="secondary"
                  size="small"
                  variant={
                    child.id === selectedChildId ? "contained" : "outlined"
                  }
                  onClick={() => setSelectedChildId(child.id)}
                  startIcon={mdUp ? child?.icon : null}
                >
                  {child.buttonName}
                </Button>
              ))}
            </Box>

            <IconButton
              sx={{
                visibility: "hidden",
                bgcolor: "primary.main",
                color: "white",
                "&:hover": {
                  bgcolor: "info.dark",
                },
              }}
              onClick={() => scrollChild("right")}
              size="small"
            >
              <Icon icon="mdi:chevron-right" width={20} height={20} />
            </IconButton>
          </Box>
        )}

        {childItems.length > 0 && <Divider />}
      </Box>
      <Box p={mdUp ? 1 : 0.5}>{renderedComponent}</Box>
    </>
  );
};

export default DynamicTopMainAndSubNavbar;
